"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Button_1 = require("../../Button");
var Styling_1 = require("../../Styling");
var BaseButton_styles_1 = require("../Button/BaseButton.styles");
var FacepileButton = /** @class */ (function (_super) {
    tslib_1.__extends(FacepileButton, _super);
    function FacepileButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FacepileButton.prototype.render = function () {
        var baseButtonStyles = BaseButton_styles_1.getStyles(Styling_1.getTheme());
        return (React.createElement(Button_1.BaseButton, tslib_1.__assign({}, this.props, { styles: baseButtonStyles })));
    };
    return FacepileButton;
}(Utilities_1.BaseComponent));
exports.FacepileButton = FacepileButton;
//# sourceMappingURL=FacepileButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Facepile/FacepileButton.js
// module id = 983
// module chunks = 0